import get from "lodash/get";
import BaseProxy from "../../base-proxy";

/**
 * @class GetCompanyUsersProxy
 * @description Class used for communicating GET requests with company users API.
 * @author Allan Chua
 * @version 1.0
 * @since December 03, 2018
 */
export default class GetCompanyUserProxy {
  getOptionsQuery(options = {}) {
    const load = get(options, "load", []);
    const lean = load.length ? false : get(options, "lean", true);
    return new URLSearchParams({
      load: load,
      lean: lean,
      include_pagination_metadata: true,
      current_user_only: get(options, "current_user_only", false),
      page: get(options, "page", 1),
      limit: get(options, "limit", 20),
    }).toString();
  }

  async getCompanyUsers(input, collated = [], isUsingCache = true) {
    const response = await this._getCompanyUsers(input, isUsingCache);
    const companyUsers = collated.concat(response.result);
    if (response.result.length && response.metadata.next_page) {
      input.options = input.options || {};
      input.options.page = response.metadata.next_page;
      return this.getCompanyUsers(input, companyUsers, isUsingCache);
    }
    return companyUsers;
  }

  async _getCompanyUsers(input, isUsingCache = true) {
    const query = this.getOptionsQuery(input.options);
    const baseProxy = new BaseProxy();
    const backendUrl = await baseProxy.getBackendUrl();
    const endpointUrl = `${backendUrl}/companies/${input.id}/company-users/?${query}`;
    if (isUsingCache) {
      return await baseProxy.getAuthenticatedData(endpointUrl, input.authToken);
    } else {
      return await baseProxy.getAuthenticatedUncachedData(endpointUrl, input.authToken);
    }
  }

  /**
   * @async
   * @function execute
   * @param input - Input parameter instance.
   * @param {String} input.id - Company id.
   * @param {String} input.authToken - Token used for issuing authenticated request.
   */
  async execute(input = {}, isUsingCache = true) {
    return await this.getCompanyUsers(input, [], isUsingCache);
  }

  async getById(input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/company-users/${input.id}`;

    return await baseProxy.getAuthenticatedData(endpointUrl, input.authToken);
  }
}
